import { MeetingTranscriptData } from '../../../../../extViewmodels/sdk/models/Zoom';

/**
 * Formats bulk transcript data into a combined string ready for AI analysis
 * Returns a formatted string with each transcript separated by delimiters
 */
export const formatBulkTranscripts = (transcripts: MeetingTranscriptData[]): string => {
	if (!transcripts || transcripts.length === 0) {
		return '';
	}

	const formattedTranscripts = transcripts.map((transcript, index) => {
		const parts: string[] = [];

		parts.push(`Recording ${index + 1}:`);

		if (transcript.meetingTopic) {
			parts.push(`  Meeting Topic: ${transcript.meetingTopic}`);
		}

		if (transcript.meetingDate) {
			const date = new Date(transcript.meetingDate);
			const meetingDate = date.toISOString().split('T')[0];
			const meetingTime = date.toLocaleTimeString();
			parts.push(`  Meeting Date: ${meetingDate}`);
			parts.push(`  Meeting Time: ${meetingTime}`);
		}

		if (transcript.transcriptContent) {
			parts.push(`  Transcript:\n${transcript.transcriptContent}`);
		}

		return parts.join('\n');
	});

	return formattedTranscripts.join('\n\n-------end demo--------\n\n');
};
